import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../shared/colors';
import t from '../shared/translations';
import Logo from './Logo';

const FooterElem = styled.footer`
    display: flex;
    flex-direction: column;
    > * {
        text-align: center;
        flex-grow: 1;
        flex-basis: 0;
        font-size: 0.9em;
    }
    align-items: center;
    margin-top: 2rem;
    margin-block-end: 0.5rem;
    padding-top: 0.3rem;
    @media (min-width: 500px) {
        flex-direction: row;
    }
    border-top: 1px solid ${colors.unlight};
`;

const FooterLogo = styled(Logo)`
    flex-shrink: 0;
    height: 1.5rem!important;

    @media (min-width: 600px) {
        max-width: 33%;
    }
`;

function Footer(): JSX.Element {
    return <FooterElem>
        <div><FooterLogo /></div>
        <div>{t('shared.footer.copyright')}</div>
    </FooterElem>;
}

export default Footer;
